import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer, Editor } from '@ckeditor/ckeditor5-core/src/editor';
import Position from '@ckeditor/ckeditor5-engine/src/model/position';
import TreeWalker from '@ckeditor/ckeditor5-engine/src/model/treewalker';
import { TaskActiveAttibute } from '../task/insert-task-command';
import {
  CommentIdAttibute,
  CommentActiveAttibute,
} from './insert-comment-command';

interface CommandOptions {
  commentId: string;
}

export class ActiveCommentCommand extends Command {
  editor: Editor;

  constructor(editor: Editor) {
    super(editor);
    this.editor = editor;
  }

  async execute(options: CommandOptions): Promise<void> {
    const { commentId } = options || {};
    const { model } = this.editor;
    const { document } = model;

    model.change((writer: Writer) => {
      const rootBeginning = new Position(document.getRoot(), [0]);
      const iterator = new TreeWalker({ startPosition: rootBeginning });

      [...iterator].forEach((value) => {
        if (value.type === 'text') {
          const commentIdAttrValue = value.item.getAttribute(CommentIdAttibute);

          if (commentIdAttrValue && commentIdAttrValue === commentId) {
            writer.setAttribute(CommentActiveAttibute, 'active', value.item);
          } else {
            writer.removeAttribute(TaskActiveAttibute, value.item);
            writer.removeAttribute(CommentActiveAttibute, value.item);
          }
        }
      });
    });
  }
}
